<div class="loading-spinner" [class.hidden]="!loading">
    <!-- <h3>{{ 'LoadWithThreeDot' | localize }}</h3> -->
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
</div>